import EmptyResults from 'components/EmptyResults'
import ShowMoreButton from 'components/ShowMoreButton'
import { Icon, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Referral/List/subcomponents/List/referral-list.module.scss'
import { useTableConfig } from 'modules/Referral/List/subcomponents/List/hooks/useTableConfig'
import GridSpinner from 'components/UI/GridSpinner'

const ReferralList = ({ className, onChangePage, data, loading, pagination }) => {
  const { t } = useTranslation()

  const { tableState, tableConfig } = useTableConfig({}, data)

  return (
    <div className={className}>
      <List
        Loader={() => <GridSpinner width={24} />}
        loading={loading}
        table={tableState}
        config={tableConfig}
        EmptyComponent={() =>
          !loading && data.length === 0 ? (
            <EmptyResults
              icon={
                <Icon
                  name={'users'}
                  width={64}
                  height={64}
                />
              }
              className={styles['referral-list__empty']}
              header={t('referral::empty_list_header')}
              text={t('referral::empty_list')}
            />
          ) : (
            <GridSpinner />
          )
        }
      />
      <ShowMoreButton
        onClick={() => onChangePage(1)}
        loading={loading}
        showFromTo
        current={data.length}
        total={pagination.total}
      />
    </div>
  )
}

ReferralList.propTypes = {
  className: PropTypes.string,
  onChangePage: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  pagination: PropTypes.object,
}

export default ReferralList
